// extracted by mini-css-extract-plugin
export default {"input-fields":"booking_input-fields__xrvRk","guests-menu-card":"booking_guests-menu-card__U1wYT"};